import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import NavData from '../config/data/nav/nav_data.json';

import 'focus-visible';
import './font.scss';
import './reset.scss';
import './app.scss';

const ScrollToTop = React.lazy(() => import('./common/ScrollToTop'));
const Home = React.lazy(() => import('./Home/Home'));
const Header = React.lazy(() => import('./header/Header'));
const Footer = React.lazy(() => import('./footer/Footer'));

const IntroMain = React.lazy(() => import('./intro/IntroMain'));
const IntroGreeting = React.lazy(() => import('./intro/IntroGreeting'));
const IntroHistory = React.lazy(() => import('./intro/IntroHistory'));
const IntroStrategy = React.lazy(() => import('./intro/IntroStrategy'));
const IntroContact = React.lazy(() => import('./intro/IntroContact'));
const IntroHistoryDepartment = React.lazy(() => import('./intro/IntroHistoryDepartment'));
const IntroCi = React.lazy(() => import('./intro/IntroCi'));

const BusinessTv = React.lazy(() => import('./business/BusinessTv'));
const BusinessRadio = React.lazy(() => import('./business/BusinessRadio'));
const BusinessDigital = React.lazy(() => import('./business/BusinessDigital'));
const BusinessNetwork = React.lazy(() => import('./business/BusinessNetwork'));
const BusinessTvad = React.lazy(() => import('./business/BusinessTvad'));
const BusinessForeignad = React.lazy(() => import('./business/BusinessForeignad'));
const BusinessEvent = React.lazy(() => import('./business/BusinessEvent'));
const BusinessPromotion = React.lazy(() => import('./business/BusinessPromotion'));

const NoticeAnnounce = React.lazy(() => import('./notice/NoticeAnnounce'));
const NoticeEmploy = React.lazy(() => import('./notice/NoticeEmploy'));
const NoticeBid = React.lazy(() => import('./notice/NoticeBid'));
const NoticeReport = React.lazy(() => import('./notice/NoticeReport'));
const NoticePublicity = React.lazy(() => import('./notice/NoticePublicity'));
const NoticeSurvey = React.lazy(() => import('./notice/NoticeSurvey'));
const NoticeSub = React.lazy(() => import('./notice/NoticeSub'));

const JoinUse = React.lazy(() => import('./join/JoinUse'));
const JoinCsr = React.lazy(() => import('./join/JoinCsr'));
const JoinCS = React.lazy(() => import('./join/JoinCS'));
const JoinSuggest = React.lazy(() => import('./join/JoinSuggest'));
const JoinVisit = React.lazy(() => import('./join/JoinVisit.js'));
const JoinCorporate = React.lazy(() => import('./join/JoinCorporate'));
const JoinVideotip = React.lazy(() => import('./join/JoinVideotip'));
const JoinWatch = React.lazy(() => import('./join/JoinWatch'));

const InfoMain = React.lazy(() => import('./info/InfoMain'));
const InfoAnnounce = React.lazy(() => import('./info/InfoAnnounce'));
const InfoAnnounceItems = React.lazy(() => import('./info/InfoAnnounceItems'));
const InfoOpen = React.lazy(() => import('./info/InfoOpen'));
const InfoMd = React.lazy(() => import('./info/InfoMd'));
const InfoSd = React.lazy(() => import('./info/InfoSd'));
const InfoPub = React.lazy(() => import('./info/infoPub'));
const InfoEm = React.lazy(() => import('./info/InfoEm'));
const InfoHrm = React.lazy(() => import('./info/InfoHrm'));
const InfoPns = React.lazy(() => import('./info/InfoPns'));

const PolicyPersonal = React.lazy(() => import('./policy/PolicyPersonal'));
const PolicyAgree = React.lazy(() => import('./policy/PolicyAgree'));
const PolicyCopyright = React.lazy(() => import('./policy/PolicyCopyright'));
const PolicyProcess = React.lazy(() => import('./policy/PolicyProcess'));

const EsgMain = React.lazy(() => import('./esg/esgMain'));

const NotFound = React.lazy(() => import('./not_found'));

function Structure({ mode }) {
  const nav = NavData;
  const location = useLocation();
  const navLocation = location.pathname.split('/')[1];

  return (
    <>
      <ScrollToTop>
        <div className="app">
          <Header />
          <div id="container" className={`container ${navLocation === '' ? 'main' : 'sub'}`}>
            <Switch>
              <Route exact path={nav['HOME'].path} component={Home} />
              {/* 재단안내 */}
              <Route exact path={nav['menu_intro'].path} component={() => <Redirect to={nav['intro_main'].path} />} />
              <Route exact path={nav['intro_main'].path} component={IntroMain} />
              <Route exact path={nav['intro_greeting'].path} component={IntroGreeting} />
              <Route exact path={nav['intro_history'].path} component={IntroHistory} />
              <Route exact path={`${nav['intro_history_id'].path}`} component={IntroHistoryDepartment} />
              <Route exact path={nav['intro_strategy'].path} component={IntroStrategy} />
              <Route exact path={nav['intro_ci'].path} component={IntroCi} />
              <Route exact path={nav['intro_contact'].path} component={IntroContact} />

              {/* 사업안내 */}
              <Route
                exact
                path={nav['menu_business'].path}
                component={() => <Redirect to={nav['business_tv'].path} />}
              />
              <Route exact path={nav['business_tv'].path} component={BusinessTv} />
              <Route exact path={nav['business_radio'].path} component={BusinessRadio} />
              <Route exact path={nav['business_digital'].path} component={BusinessDigital} />
              <Route exact path={nav['business_network'].path} component={BusinessNetwork} />
              <Route exact path={nav['business_tvad'].path} component={BusinessTvad} />
              <Route exact path={nav['business_foreignad'].path} component={BusinessForeignad} />
              <Route exact path={nav['business_promotion'].path} component={BusinessPromotion} />
              <Route exact path={nav['business_event'].path} component={BusinessEvent} />

              {/* 알림마당 */}
              <Route
                exact
                path={nav['menu_notice'].path}
                component={() => <Redirect to={nav['notice_announce'].path} />}
              />
              <Route exact path={nav['notice_announce'].path} render={(props) => <NoticeAnnounce {...props} />} />
              <Route path={nav['notice_announce_id'].path} render={(props) => <NoticeSub mode={mode} {...props} />} />
              <Route exact path={nav['notice_employ'].path} render={(props) => <NoticeEmploy {...props} />} />
              <Route path={nav['notice_employ_id'].path} render={(props) => <NoticeSub mode={mode} {...props} />} />
              <Route exact path={nav['notice_bid'].path} render={(props) => <NoticeBid {...props} />} />
              <Route path={nav['notice_bid_id'].path} render={(props) => <NoticeSub mode={mode} {...props} />} />
              <Route exact path={nav['notice_report'].path} render={(props) => <NoticeReport {...props} />} />
              <Route path={nav['notice_report_id'].path} render={(props) => <NoticeSub mode={mode} {...props} />} />
              <Route exact path={nav['notice_publicity'].path} component={NoticePublicity} />
              <Route
                exact
                path={nav['notice_survey'].path}
                render={(props) => <NoticeSurvey mode={mode} {...props} />}
              />
              <Route path={nav['notice_survey_id'].path} render={(props) => <NoticeSub mode={mode} {...props} />} />

              {/* 고객센터 */}
              <Route exact path={nav['menu_join'].path} component={() => <Redirect to={nav['join_cs'].path} />} />
              <Route exact path={nav['join_use'].path} component={JoinUse} />
              <Route exact path={nav['join_cs'].path} render={(props) => <JoinCS mode={mode} {...props} />} />
              <Route exact path={nav['join_suggest'].path} component={JoinSuggest} />
              <Route exact path={nav['join_visit'].path} component={JoinVisit} />
              <Route exact path={nav['join_videotip'].path} component={JoinVideotip} />
              <Route exact path={nav['join_corporate'].path} component={JoinCorporate} />
              <Route exact path={nav['join_csr'].path} component={JoinCsr} />
              <Route exact path={nav['join_watch'].path} component={JoinWatch} />

              {/* 정보공개 */}
              <Route exact path={nav['menu_info'].path} component={() => <Redirect to={nav['info_main'].path} />} />
              <Route exact path={nav['info_main'].path} component={InfoMain} />
              <Route exact path={nav['info_announce'].path} component={InfoAnnounce} />
              <Route exact path={nav['info_announce_id'].path} component={InfoAnnounceItems} />
              <Route exact path={nav['info_md'].path} component={InfoMd} />
              <Route exact path={nav['info_sd'].path} component={InfoSd} />
              <Route exact path={nav['info_open'].path} component={InfoOpen} />
              <Route exact path={nav['info_pub'].path} component={InfoPub} />
              <Route exact path={nav['info_em'].path} component={InfoEm} />
              <Route exact path={nav['info_hrm'].path} component={InfoHrm} />
              <Route exact path={nav['info_pns'].path} component={InfoPns} />

              {/* ESG */}
              <Route exact path={nav['menu_esg'].path} component={() => <Redirect to={nav['esg_main'].path} />} />
              <Route exact path={nav['esg_main'].path} render={(props) => <Redirect to={nav['esg_task'].path} />} />
              <Route exact path={nav['esg_e'].path} render={(props) => <Redirect to={nav['esg_issues'].path} />} />
              <Route exact path={nav['esg_s'].path} render={(props) => <Redirect to={nav['esg_job'].path} />} />
              <Route exact path={nav['esg_g'].path} render={(props) => <Redirect to={nav['esg_upright'].path} />} />
              <Route exact path={nav['esg_task'].path} render={(props) => <EsgMain {...props} />} />
              <Route exact path={nav['esg_org'].path} render={(props) => <EsgMain {...props} />} />
              <Route exact path={nav['esg_issues'].path} render={(props) => <EsgMain {...props} />} />
              <Route exact path={nav['esg_greenhouse'].path} render={(props) => <EsgMain {...props} />} />
              <Route exact path={nav['esg_enviro'].path} render={(props) => <EsgMain {...props} />} />
              <Route exact path={nav['esg_job'].path} render={(props) => <EsgMain {...props} />} />
              <Route exact path={nav['esg_make'].path} render={(props) => <EsgMain {...props} />} />
              <Route exact path={nav['esg_busi'].path} render={(props) => <EsgMain {...props} />} />
              <Route exact path={nav['esg_upright'].path} render={(props) => <EsgMain {...props} />} />
              <Route exact path={nav['esg_human'].path} render={(props) => <EsgMain {...props} />} />
              <Route exact path={nav['esg_public'].path} render={(props) => <EsgMain {...props} />} />

              {/* PRIVACY POLICY */}
              <Route exact path={nav['policy_personal'].path} render={(props) => <PolicyPersonal {...props} />} />
              <Route exact path={nav['policy_agree'].path} component={PolicyAgree} />
              <Route exact path={nav['policy_copyright'].path} component={PolicyCopyright} />
              <Route exact path={nav['policy_process'].path} render={(props) => <PolicyProcess {...props} />} />

              <Route exact path={nav['NOT_FOUND'].path} component={NotFound} />
            </Switch>
          </div>
          <Footer />
        </div>
      </ScrollToTop>
    </>
  );
}

export default Structure;
